import React, { Component } from "react";
import ReactGA from "react-ga";

import "./assets/css/App.css";

// Importar sonidos
import sFxClick from "./assets/sound/fx/Click.mp3";
import sFxPruebaDeNuevo from "./assets/sound/fx/ApruebaDeNuevo.mp3";
import sFxCorrecto from "./assets/sound/narracion/CORRECTO.mp3";
import sFxAplausos from "./assets/sound/fx/Aplausos.mp3";
// import sNarracion_Fin from "./assets/sound/narracion/Final.mp3";

// Importar componentes
import Juego from "./components/Juego";
import Inicio from "./components/juegos/Inicio";

function initializeReactGA() {
  ReactGA.initialize("UA-156942327-2");
  ReactGA.pageview("/homepage");
  ReactGA.pageview(window.location.pathname + window.location.search);
}

initializeReactGA();

class App extends Component {
  constructor() {
    super();
    this.modal = React.createRef();
    this.cerrar = this.cerrar.bind(this);
  }

  cerrar() {
    this.modal.current.style.display = "none";

    const new_sNarracion = document.getElementsByClassName("sNarracion")[0];
    new_sNarracion.muted = false;
    new_sNarracion.currentTime = 0;
    new_sNarracion.play();

    const new_sFx = document.getElementsByClassName("sFxClick")[0];
    new_sFx.play();
  }

  render() {
    return <Inicio />;
  }
}

export default App;
